import React from 'react';
import Navbar from './componets/Navbar';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.css';
import Home from './componets/pages/Home';
import About from './componets/pages/About';
import Stations from './componets/pages/Stations';
import Login from './componets/pages/Login';
import Footer from './componets/Footer';
import TransparencySeal from './componets/pages/TransparencySeal';
import Contact from './componets/pages/Contact';

function App() {
  return (
 <>
 <Router>
      <Navbar />
      <Switch>
        <Route path='/' exact component={Home}/>
        <Route path='/about' exact component={About}/>
        <Route path='/stations' exact component={Stations}/>
        {/* <Route path='/transparencyseal' exact component={TransparencySeal}/> */}
        <Route path='/contact' exact component={Contact}/>
        {/* <Route path='/' exact component={Login}/> */}
      </Switch>
      <Footer/>
 </Router>

  </>
  );
}

export default App;
